import UnpicImage from "@/components/common/unpicImage/UnpicImage";
import { type IGenBlogArticle, type IGenNewsArticle } from "@/services/graphql/__generated/sdk";
import { type NewsOrBlog } from "@/utils/types";

import Link from "next/link";
import React, { type FunctionComponent } from "react";

import * as styles from "./BlogArticle.style";

const BlogArticle: FunctionComponent<(IGenBlogArticle | IGenNewsArticle) & { readonly isFeatured?: boolean; readonly newsOrBlog: NewsOrBlog }> = ({
  category,
  estimatedReadingTime,
  excerpt,
  image,
  isFeatured,
  newsOrBlog,
  slug,
  title
}) => (
  <Link key={slug} href={`/${newsOrBlog}/${slug}`} css={[styles.wrapper, isFeatured ? styles.wrapperFeatured : styles.wrapperNotFeatured]}>
    <div css={[styles.imageWrapper, isFeatured ? styles.imageWrapperFeatured : styles.imageWrapperNotFeatured]}>
      <UnpicImage
        layout="fullWidth"
        src={image?.src || ""}
        alt={image?.title || ""}
        background="auto"
      />
    </div>
    <div css={[styles.contentWrapper, isFeatured ? styles.contentWrapperFeatured : styles.contentWrapperNotFeatured]}>
      <div>
        <h2 className="title">{title}</h2>
        <p className="excerpt">{excerpt}</p>
      </div>
      {(estimatedReadingTime || category?.title) && (
        <div css={styles.categoryAndTitleWrapper}>
          {estimatedReadingTime && (
            <p className="reading-time">{estimatedReadingTime}</p>
          )}
          {category?.title && (
            <p className="category">{category.title}</p>
          )}
        </div>
      )}
    </div>
  </Link>
);

export default BlogArticle;
